import { Label } from '@/components/ui/label'

/** A checkbox with its label and a line saying what it does. */
export function Toggle({
  id, label, hint, checked, onChange, disabled,
}: {
  id: string
  label: string
  hint?: string
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}) {
  return (
    <div className="flex items-start gap-3">
      <input
        id={id}
        type="checkbox"
        className="mt-1 h-4 w-4 accent-[var(--color-primary)]"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <div>
        <Label htmlFor={id}>{label}</Label>
        {hint && <p className="text-xs text-[var(--color-muted)]">{hint}</p>}
      </div>
    </div>
  )
}
